var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('div',{staticClass:"home"},[(!_vm.empty)?_c('Form',{attrs:{"company":_vm.ngo}}):_c('div',[_vm._v(" something went wrong....... yep, thats all we know.")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }